module.exports = __webpack_public_path__ + "img/1574929872.ae70f041.jpg";